import React, { createContext, useContext, useState, useEffect } from 'react';
import { SessionContext } from './SessionProvider';
import Keycloak from 'keycloak-js'

const KeycloackContext = createContext()

const KeycloackContextProvider = (props) => {
    const { setUser, getDevice } = useContext(SessionContext)

    const [ userKeycloak, setUserKeycloak] = useState(null)
    const [ authenticated, setAuthenticated] = useState(false)
    const [ isAdminRole, setIsAdminRole] = useState(false)
    const [ tokenValue, settokenValue ] = useState(null)
    const [ parsedTokenValue, setparsedTokenValue ] = useState(null)

    
    useEffect(()=>{
        const keycloak = new Keycloak('/keycloak.json');
        keycloak.init({ onLoad: 'login-required', checkLoginIframe: false }).then(authenticated => {
            setUserKeycloak(keycloak)
            setAuthenticated(authenticated);
            settokenValue(keycloak.token);
            setparsedTokenValue(keycloak.tokenParsed);
            setUser(keycloak.tokenParsed)
            setIsAdminRole(isUserAdmin(keycloak.tokenParsed))
        })
        // eslint-disable-next-line
      }, [])

    const logout = () => {
        setUserKeycloak(null)
        setAuthenticated(false)
        userKeycloak.logout()
    }

    const isUserAdmin = (token) => {
        const isSmallDevice = getDevice();
        if (token.realm_access.roles.includes("admin") && !isSmallDevice) {
            return true
        }
        else return false;
    }

    return (
    <KeycloackContext.Provider
        value={{
            userKeycloak,
            tokenValue,
            parsedTokenValue,
            authenticated,
            logout,
            isAdminRole
        }}
    >
        {props['children']}
    </KeycloackContext.Provider>
    )
}

export { KeycloackContextProvider, KeycloackContext }
